<template>
  <div class="fotter">
    <div class="footerCon">
      <div class="Con1">
        <div class="title">联系我们</div>
        <ul>
          <li><span>全称：</span><span>九不欺</span></li>
          <li><span>邮编：</span><span>200433</span></li>
          <li><span>电话：</span><span>021-60665325</span></li>
          <li><span>邮箱：</span><span>wangxinyi@lawxp.com</span></li>
        </ul>
      </div>
      <div class="Con2">
        <div class="downEwm">
          <div class="title">关注九不欺</div>
          <img src="@/assets/images/index/ewm.png" />
          <p>关注公众号</p>
        </div>
      </div>
    </div>
    <div class="footerBom">
      <p>
        网站备案号:<a target="_blank" href="https://beian.miit.gov.cn">
          ICP备案号:沪ICP备2020033094号-7
        </a>
        <span class="rights_">经营许可证编号：沪B2-20211583 </span>
      </p>
      <p>Copyright(C) 2021 上海汇法正信信息科技有限公司 All Rights Reserved</p>
      <p style="display: flex; justify-content: center; margin-top: 10px">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005872"
          style="display: flex; align-items: center"
          ><img src="../../assets/images/warn.png" style="width: 18px" /> &nbsp;
          <p>沪公网安备 31011002005872号</p>
        </a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "footers",
  mounted() {},
  methods: {
    downClick(val) {
      let url = "http://d.firim.top/8gd9";
      if ((val = 1)) {
        //andriod :
        url = "http://d.firim.top/fqrg";
      }
      window.location.href = url;
    },
  },
};
</script>
<style lang="less" scoped>
.fotter {
  max-width: 7.5rem;
  .footerCon {
    display: flex;
    justify-content: space-between;
    background: #2b2d2e;
    width: 100%;
    padding: 0.52rem 0.3rem;
    box-sizing: border-box;
    .title {
      font-size: 0.32rem;
      color: #ffffff;
    }
    .Con1 {
      ul {
        margin-top: 0.3rem;
        li {
          font-size: 0.26rem;
          color: #cccccc;
          line-height: 0.46rem;
        }
      }
    }
    .Con2 {
      width: 2rem;
      text-align: center;
      img {
        width: 1.23rem;
        margin: 0 auto;
        margin-top: 0.28rem;
        margin-bottom: 0.22rem;
      }
      p {
        font-size: 0.22rem;
        color: #cccccc;
      }
    }
  }
  .footerBom {
    width: 100%;
    background: #131414;
    padding: 0.35rem 0.44rem;
    box-sizing: border-box;
    font-size: 0.22rem;
    color: #cccccc;
    text-align: center;
    p {
      line-height: 0.36rem;
    }
    a {
      font-size: 0.22rem;
      color: #cccccc;
    }
    .rights_ {
      display: inline-block;
      margin-left: 0.2rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/footerrem.vue